export const convertRowsToCSV = (rows) => {
  const formatCsvValue = (value) => {
    const stringValue = String(value ?? '');
    const isNumericString = stringValue.trim() !== '' && !Number.isNaN(Number(stringValue));
    const safeValue = typeof value === 'string' && !isNumericString && /^[\s\t\r\n]*[=+\-@]/.test(stringValue) ? `'${stringValue}` : stringValue;
    const escapedValue = safeValue.replace(/"/g, '""');

    return /[",\r\n]/.test(escapedValue) ? `"${escapedValue}"` : escapedValue;
  };

  return rows.map((row) => row.map(formatCsvValue).join(',')).join('\n');
};
